<template>
    <div class="application-wrapper">
        <navbar v-if="$isAuthorized()"></navbar>
        <router-view/>
        <preloader-block/>
    </div>
</template>

<script>

    export default {
        components: {},
        name: 'App'
    }
</script>

<style scoped lang="scss">
    .application-wrapper{
        margin-top: 40px;
    }
    body{
        color: $globalColor;
    }
</style>



// WEBPACK FOOTER //
// src/App.vue